import { useEffect } from 'react'
import { useModalStore } from 'src/stores/ModalStore'
import styled from 'styled-components'
import { ActionButton, NextButton } from '../common/CommonStyled'
import { Divider } from '@mui/material'
import { useAdTeamStore } from 'src/stores/AdTeamStore'
import { postCreateTeam } from 'src/api/Admin'
import { LoadTeam } from './useLoadTeam'
import { toast } from 'react-toastify'

const PageWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    position: relative;
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 20px;
`
const ButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;

    height: 54px;
    position: absolute;
    right: 0;
`

const ModalTitleCreateTeam = () => {
    const modalSetField = useModalStore((state)=>state.setField)
    const team_name = useAdTeamStore((state)=>state.team_name)
    const manager_uid = useAdTeamStore((state)=>state.manager_uid)
    const memberList = useAdTeamStore((state)=>state.memberList)
    const team_areas = useAdTeamStore((state)=>state.team_areas)
    const reset = useAdTeamStore((state)=>state.reset)
    const regionArray: [string, string[]][] = Object.entries(team_areas);
    useEffect(()=>{
        return(()=>{
            reset(['selectedTeam','tableData'])
        })
    },[])

    const member_uids = memberList.map((member) => member.uid);

    const onClickSubmit = async ()=>{
        if(!team_name) return toast.error('팀 명이 없습니다.',{autoClose:2000})
        const response = await postCreateTeam({
            team_name, 
            manager_uid,
            member_uids: member_uids,
            team_areas: regionArray})
        
        if(response.status === 200){
            LoadTeam()
            modalSetField('open',false)
        }
        else{
            return
        }
    }
    return (
        <>
        <PageWrapper>
            팀 생성
            <ButtonWrapper>
                <ActionButton style={{width:'94px', height: '54px'}} onClick={()=>modalSetField('open',false)}>취소</ActionButton>
                <NextButton style={{width:'94px', height:'100%'}} onClick={onClickSubmit} disabled={false}>추가</NextButton>
            </ButtonWrapper>
        </PageWrapper>
        <Divider sx={{width:'100%', borderColor:'#D1D1D1'}}/>
        </>
    )
}

export default ModalTitleCreateTeam